import { z } from "zod";

const DailyDetailRowSchema = z.object({
    date: z.string().nullable(),
    invoice_number: z.string().nullable(),
    customer_name: z.string().nullable(),
    room_number: z.string().nullable(),
    checkin_date: z.string(),
    checkout_date: z.string(),
    rate: z.coerce.number(),
});

const DailyDetailTotalSchema = z.object({
    reservations: z.number(),
    nights: z.number(),
    total_earning: z.string(),
});

export const DailyDetailResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(DailyDetailRowSchema),
    total: DailyDetailTotalSchema,
});

export type DailyDetailResponse = z.infer<typeof DailyDetailResponseSchema>;
export type DailyDetailRow = z.infer<typeof DailyDetailRowSchema>;
